import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import checkIfEmailExist from 'modules/training/modules/app-auth/actions/check-if-email-exist'
import logInAppAuthAction from 'modules/training/modules/app-auth/actions/log-in'
import resetTrainingAuthAction from 'modules/training/modules/app-auth/actions/reset'
import resetPasswordAction from 'modules/training/modules/app-auth/actions/reset-password'
import toggleLogInTypeTrainingAuthAction from 'modules/training/modules/app-auth/actions/toggle-log-in-type'
import updateTrainingEmailOrNameAuthAction from 'modules/training/modules/app-auth/actions/update-email-or-name'
import getEmailOrNameTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/get-email-or-name'
import getErrorTrainingAuthSelector from 'modules/training/modules/app-auth/selectors/get-error'
import getPasswordTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/get-password'
import isSuccessAuthSelector from 'modules/training/modules/app-auth/selectors/is-success'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import {
  PROFILE_KEY,
  USER_KEY
} from '@gymaholic/packages'
import getEmailTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/get-email'
import updateEmailTrainingAuthAction from 'modules/training/modules/app-auth/actions/update-email'
import { logUtil } from 'packages/src'
import isEmailStringUtil from 'utils/string/is-email'
import SigninSignupFlowForgotPassword from 'pages/SigninSignupFlow/ForgotPassword/index.js'
import SigninSignupFlowForgotPasswordSuccess from 'pages/SigninSignupFlow/ForgotPasswordSuccess/index.js'
import SigninSignupFlowSignInSignUp from 'pages/SigninSignupFlow/SigInSignUp/index.js'
import navigateToCurrentProfileAction from 'modules/profile/redux/actions/navigate-to-current-profile/index.js'

const messages = defineMessages({
  enterYourEmailOrName: {
    id: 'SigninSignupFlow.enterYourEmailOrName',
    defaultMessage: 'Enter your email or name'
  }
})

export default function SigninSignupFlow (props) {
  const {
    onSuccess,
    onClose,
    isCreator,
    forgotPasswordDoneButtonHide,
    onEmailExistCheck,
    isOnboarding
  } = props

  let { title } = props
  const dispatch = useDispatch()
  const intl = useIntl()
  title = title || formatMessageIntlUtil(intl, messages.enterYourEmailOrName)
  const [loading, setLoading] = React.useState(false)
  const emailOrName = useSelector(getEmailOrNameTrainingAuthSelect)
  const isEmail = isEmailStringUtil(emailOrName)
  const email = useSelector(getEmailTrainingAuthSelect)
  const password = useSelector(getPasswordTrainingAuthSelect)
  const isAuthSuccess = useSelector(isSuccessAuthSelector())
  const authError = useSelector(getErrorTrainingAuthSelector())
  // const isEmailOrNameValid = isEmailOrNameValidatorUtil(email)
  const isEmailOrNameValid = !!emailOrName
  const [isInvalidEmailOrNameField, setIsInvalidEmailOrNameField] = React.useState(false)
  const [exists, setExists] = React.useState(null)
  const [isForgotPasswordVisible, setIsForgotPasswordVisible] = React.useState(false)
  const [isEmailVisible, setIsEmailVisible] = React.useState(false)
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false)
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = React.useState(false)

  const debugProps = {
    email,
    emailOrName,
    props
  }
  logUtil('SigninSignupFlow').debug('debugProps=', debugProps)

  React.useEffect(() => {
    if (isAuthSuccess && loading) {
      if (onSuccess) {
        onSuccess()
      }
      dispatch(resetTrainingAuthAction())
      setLoading(false)
      if (onClose) {
        onClose()
      }
    }
  }, [isAuthSuccess])

  React.useEffect(() => {
    if (authError) {
      setLoading(false)
    }
  }, [authError])

  const handleClickNext = async () => {
    try {
      setLoading(true)
      const data = {}

      const value = isEmailVisible ? email : emailOrName
      let isEmail
      if (isEmailStringUtil(value)) {
        data[USER_KEY.EMAIL] = value
        isEmail = true
      } else {
        data[USER_KEY.NAME] = value
      }
      if (isEmailVisible) {
        data[USER_KEY.NAME] = emailOrName
      }

      const debugProps = {
        isEmailVisible,
        data,
        value,
        email,
        emailOrName
      }
      logUtil('SigninSignupFlow#handleClickNext').debug('debugProps=', debugProps)
      const response = await dispatch(checkIfEmailExist(data))
      const existsRes = !!response.data.exists
      setExists(existsRes)
      if (onEmailExistCheck) {
        onEmailExistCheck(existsRes)
      }
      dispatch(toggleLogInTypeTrainingAuthAction(!existsRes))
      setLoading(false)

      if (existsRes && isEmailVisible) {
        dispatch(updateTrainingEmailOrNameAuthAction(email))
        setIsEmailVisible(false)
        setIsPasswordVisible(true)
        return
      }

      if (existsRes || isEmail) {
        setIsPasswordVisible(true)
        return
      }

      setIsEmailVisible(true)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleChangeEmail = (event) => {
    const value = event.target.value
    dispatch(updateEmailTrainingAuthAction(value))
    setIsInvalidEmailOrNameField(false)
  }

  const handleChangeEmailOrName = (event) => {
    dispatch(updateTrainingEmailOrNameAuthAction(event.target.value))
    setIsInvalidEmailOrNameField(false)
  }

  const handleClickSubmit = async () => {
    logUtil('SigninSignupFlow#handleClickSubmit').debug('[start]')
    if (!isPasswordVisible) {
      handleClickNext()
      return
    }

    setLoading(true)

    const res = await dispatch(
      logInAppAuthAction({
        isCreator,
        isOnboarding
      })
    )

    if (!isOnboarding) {
      return
    }

    const profileName = res?.profiles?.[0]?.[PROFILE_KEY.NAME]
    dispatch(navigateToCurrentProfileAction(profileName))
  }

  const handleSubmitForgotPassword = async () => {
    setLoading(true)
    const data = {}
    if (isEmailStringUtil(emailOrName)) {
      data[USER_KEY.EMAIL] = emailOrName
    } else {
      data[USER_KEY.NAME] = emailOrName
    }
    const response = await dispatch(resetPasswordAction(data))
    if (response.status === 200) {
      setForgotPasswordSuccess(true)
    }
    setLoading(false)
  }

  const handleClickBack = () => {
    if (isForgotPasswordVisible) {
      setIsForgotPasswordVisible(false)
      return
    }

    setExists(null)

    if (isPasswordVisible) {
      setIsPasswordVisible(false)
      return
    }

    if (isEmailVisible) {
      setIsEmailVisible(false)
    }
  }

  const propsToPass = {
    handleClickBack,
    loading,
    emailOrName,
    handleChangeEmailOrName,
    setIsInvalidEmailOrNameField,
    isEmailOrNameValid,
    isInvalidEmailOrNameField,
    handleSubmitForgotPassword,
    onClose,
    forgotPasswordDoneButtonHide,
    isEmailVisible,
    isEmail,
    exists,
    email,
    title,
    handleChangeEmail,
    isPasswordVisible,
    password,
    setIsForgotPasswordVisible,
    handleClickSubmit,
    isOnboarding
  }

  let element
  if (isForgotPasswordVisible && forgotPasswordSuccess) {
    element = <SigninSignupFlowForgotPasswordSuccess {...propsToPass} />
  } else if (isForgotPasswordVisible) {
    element = <SigninSignupFlowForgotPassword {...propsToPass} />
  } else {
    element = <SigninSignupFlowSignInSignUp {...propsToPass} />
  }
  return (
    <View
      px='32px'
      pt={exists === null ? '24px' : 0}
      pb='24px'
    >
      {element}
    </View>
  )
}
